/**
 * How long a document has been parked, from `pending_since`.
 * Returns null for absent, unparseable or future timestamps — the marker table
 * and the lifecycle live in different databases, so never fabricate a date.
 */
export function formatWaiting(iso, now = Date.now()) {
  if (!iso) return null;
  const started = Date.parse(iso);
  if (Number.isNaN(started)) return null;

  const minutes = Math.floor((now - started) / 60000);
  if (minutes < 0) return null;
  if (minutes < 60) return 'waiting under an hour';

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `waiting ${hours} hour${hours === 1 ? '' : 's'}`;

  const days = Math.floor(hours / 24);
  return `waiting ${days} day${days === 1 ? '' : 's'}`;
}

export default formatWaiting;
